import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Log } from 'src/interfaces/log';
import { LogViewDialogComponent } from '../components/log-view-dialog/log-view-dialog.component';
import { AlertService } from './alert.service';
import { AuthService } from './auth.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  baseUrl: string = environment.api.baseUrl;
  headers: HttpHeaders;
  totalNumberOfLogs: number = 0;
  constructor(
    private _http: HttpClient,
    private _alertService: AlertService,
    private _auth: AuthService,
    private _dialog: MatDialog,
    private _utilsService: UtilsService
  ) {
    this
      ._auth
      .generateRequestHeaders()
      .then((headers) => {
        this.headers = headers;
      })
  }

  async getLogs(
    page: number = 1,
    limit: number = 10,
    search: string = "",
    start_date: string | null = null,
    end_date: string | null = null
  ): Promise<Log[]> {

    let queryString = `?page=${page}&limit=${limit}`;

    if (search) {
      queryString += `&search=${search}`;
    }

    if (start_date && end_date) {
      queryString += `&start_date=${start_date}&end_date=${end_date}`;
    }

    try {
      const response = await firstValueFrom(
        this._http.get<{ data?: { results?: Log[]; total?: number } }>(
          `${this.baseUrl}/log${queryString}`,
          {
            headers: this.headers,
          }
        )
      );
      const data = response?.data;
      this.totalNumberOfLogs = data?.total ?? 0;
      return data?.results ?? [];
    } catch (error) {
      this._utilsService.showError(error);
      return [];
    }
  }

  getTotalNumberOfLogs(): number {
    return this.totalNumberOfLogs;
  }

  openLogViewDialog(
    log: Log,
    title: string = "View log",
    message: string = "On the left is old value, on the right is new value"): Promise<any> {

    const dialogRef = this._dialog.open(LogViewDialogComponent, {
      width: '800px',
      maxWidth: 'min(96vw, 800px)',
      panelClass: 'mbp-confirm-dialog',
      data: {
        title,
        message,
        log
      }
    });

    return dialogRef.afterClosed().toPromise();
  }
}